var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"DutyActivityNoLineEnd_RhB",attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }